import React, { useEffect, useState } from "react";
import { Hide, Show } from "react-iconly";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "./register.scss";
import {
  getService,
  sendOtp,
  sendOtpSignUp,
} from "../../services/auth.service";
import { usersignup } from "../../services/auth.service";
import { toast } from "react-toastify";
import { ImageUpload, Trash } from "../../components/Icons";
import { FormGroup } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { registerProvider } from "../../slice/registerSlice";
import { setLoader } from "../../slice/commonSlice";
import { getContent, getAllContent } from "../../services/auth.service";
import MarketingEmailModal from "../marketingEmailModal/MarketingEmailModal";

const RegisterConsumer = (props) => {
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);
  const [showMarketingModal, setShowMarketingModal] = useState(false);
  const [step, setStep] = useState(1);
  const [image, setImage] = useState(null);
  const [image1, setImage1] = useState(null);
  const [image2, setImage2] = useState(null);

  const [image3, setImage3] = useState(null);
  const [image4, setImage4] = useState(null);

  const [input, setInput] = useState({});
  const [selectedOption, setSelectedOption] = useState();
  const [selectedOption1, setSelectedOption1] = useState();

  const [isChecked, setChecked] = useState(false);
  const [isCheckedInd, setCheckedInd] = useState(false);
  const [isMarketingSubChecked, setMarketingSubChecked] = useState(false);

  const [services, setServices] = useState([]);

  const [activeTab, setActiveTab] = useState("tabcompany");
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(
      (prevShowConfirmPassword) => !prevShowConfirmPassword
    );
  };

  const [loading, setLoading] = useState(false);
  const [signUpModal, setSignUpModal] = useState(false);

  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const [errorsNext, setErrorsNext] = useState({
    profilePic: "",
    signature: "",
    passportOrLicense: "",
    contract: "",
    expertise: "",
    marketingEmail: "",
    marketingEmailCheck: "",
  });
  const [errorsNext1, setErrorsNext1] = useState({
    signatureind: "",

    passportOrLicenseInd: "",
    contract: "",
    expertiseInd: "",
    marketingEmail: "",
    marketingEmailCheck: "",
  });

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    phone: "",
    profilePic: "",
    signature: "",
    businessLicense: "",
    passportOrLicense: "",
    businessLicenseInd: "",
    passportOrLicenseInd: "",
    signatureind: "",
    profile: "",
    marketingEmail: "",
  });
  const [contentId, setContentId] = useState();
  const [content, setContent] = useState();
  const handleToggleModal = () => {
    setShowModal(!showModal);
  };

  //Selecting the file for individual functions

  const onFileChange1 = (e) => {
    setFormData((previous) => ({
      ...previous,
      businessLicense: e.target.files[0],
    }));
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage1(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const onFileChange5 = (e) => {
    setFormData((previous) => ({
      ...previous,
      profile: e.target.files[0],
    }));

    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const onFileChange2 = (e) => {
    setFormData((previous) => ({
      ...previous,
      passportOrLicense: e.target.files[0],
    }));
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage2(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  //----------------------------------

  //Removing Images

  const handleRemoveImage = () => {
    setInput((prevData) => ({
      ...prevData,
      profilePic: "",
    }));
    setImage("");
  };

  const handleRemoveImage1 = () => {
    setInput((prevData) => ({
      ...prevData,
      businessLicense: "",
    }));
    setImage1("");
    setFormData({
      ...formData,
      businessLicense: "",
    });
  };

  const handleRemoveImage2 = () => {
    setInput((prevData) => ({
      ...prevData,
      passportOrLicense: "",
    }));
    setImage2("");
    setFormData({
      ...formData,
      passportOrLicense: "",
    });
  };

  //--------------------------------

  // ****************************************************************************************
  useEffect(() => {
    // Check if Google data exists in local storage
    const googleData = localStorage.getItem("userData");
    if (googleData) {
      // Parse Google data and pre-fill the form
      const parsedGoogleData = JSON.parse(googleData);
      setFormData({
        firstName: parsedGoogleData.google_fname || "",
        lastName: parsedGoogleData.lastname || "",
        email: parsedGoogleData.google_email || "",
        profile: parsedGoogleData.pic || "",
        social_id: parsedGoogleData.google_id || "",
        verfied: parsedGoogleData.verfied || "",
        // Add other fields as needed
      });
    }

    const facebookData = localStorage.getItem("facebookData");
    const data = JSON.parse(facebookData);
    setImage(data?.picture?.data?.url);
    if (data) {
      setFormData({
        firstName: data.name.split(" ")[0],
        lastName: data.name.split(" ")[1] || "",
        email: data.email,
        profile: data.picture.data.url || "",
        social_id: data.userID || "",
        socailName: data.graphDomain,
      });
    }
  }, []); // Run this effect only once on component mount

  // *******************************************************************************************

  const getallcontent = async () => {
    const result = await getAllContent();
    const searchObject = result.data.find(
      (data) => data.slug == "contractwaiver"
    );
    setContentId(searchObject._id);
  };

  const getcontent = async () => {
    const paylaod = { _id: contentId };
    const result = await getContent(paylaod);
    setContent(result.data.content);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let res = await getService();
        setServices(res.data.services);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    getallcontent();
  }, []); // Add an empty dependency array if you want the effect to run once when the component mounts

  useEffect(() => {
    getcontent();
  }, [contentId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const redirect = () => {
    setSignUpModal(true);
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    // Convert camelCase to separate words
    const formattedFieldName = name
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase());

    // Set error for the field only if it's empty onBlur
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value.trim() === "" ? `${formattedFieldName} is required` : "",
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDropdownChange = (event) => {
    const selectedOption = [{ id: event.target.value, value: "0" }];
    setSelectedOption(JSON.stringify(selectedOption));
  };

  const handleDropdownChange2 = (event) => {
    const selectedOption = [{ id: event.target.value, value: "0" }];
    setSelectedOption1(JSON.stringify(selectedOption));
  };
  const handleCheckboxClick = () => {
    // Toggle the state when the checkbox is clicked
    setChecked(!isChecked);
  };
  const handleCheckboxClickInd = () => {
    // Toggle the state when the checkbox is clicked
    setCheckedInd(!isCheckedInd);
  };

  const handleMarketingSubCheckboxClick = () => {
    // Toggle the state when the checkbox is clicked
    setMarketingSubChecked(!isMarketingSubChecked);
  };

  const handleMarketingEmail = () => {
    // console.log("clicked");
    setShowMarketingModal(true);
  };

  const handleMarketingModal = () => {
    formData.marketingEmail = "";
    errorsNext.marketingEmail = "";
    errorsNext1.marketingEmail = "";
    setShowMarketingModal(false);
  };

  const checkRequiredFields = () => {
    // console.log("here4");

    if (activeTab === "tabcompany") {
      if (
        !selectedOption ||
        formData.passportOrLicense == "" ||
        formData.signature == "" ||
        !isChecked
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      // console.log("here5");
      if (
        !selectedOption1 ||
        formData.passportOrLicenseInd === "" ||
        formData.signatureind == "" ||
        !isCheckedInd
      ) {
        return true;
      } else {
        return false;
      }
    }
  };
  const handleSignupCompany = async (e) => {
    e.preventDefault();
    // console.log("called 1");
    if (!validateForm()) {
      return;
    }
    const formDatas = new FormData();
    formDatas.append("firstName", formData.firstName);
    formDatas.append("lastName", formData.lastName);
    formDatas.append("email", formData.email);
    formDatas.append("phone", formData.phone);
    formDatas.append("password", formData.password);
    formDatas.append("confirmPassword", formData.confirmPassword);
    formDatas.append("profilePic", formData.profile);
    formDatas.append("userType", "provider");
    formDatas.append("acceptTerms", isChecked);
    formDatas.append("social_id", formData.social_id || 0);
    formDatas.append("businessLicense", formData.businessLicense);
    formDatas.append("passportOrLicense", formData.passportOrLicense);
    formDatas.append("signature", formData.signature);
    formDatas.append("services", selectedOption);
    formDatas.append("for", "company");
    if (isMarketingSubChecked) {
      formDatas.append("marketingEmail", formData.email);
    } else if (formData.marketingEmail) {
      formDatas.append("marketingEmail", formData.marketingEmail);
    }
    // console.log(" formData.marketingEmail",  formData.marketingEmail)
    // return false
    try {
      await dispatch(setLoader(true));
      localStorage.setItem("emailForforget", formData.email);
      await dispatch(registerProvider(formDatas));
      const sendotpRes = await sendOtpSignUp({ email: formData.email });
      if (sendotpRes?.data?.status === true) {
        toast.success(sendotpRes?.data?.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        setShowMarketingModal(false);
        props.setRegisterProviderModal(false);
        props.setUserVerifiyOtpModal(true);
        await dispatch(setLoader(false));
      } else {
        toast.warning(sendotpRes?.data?.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        await dispatch(setLoader(false));
        props.setRegisterProviderModal(false);
      }
    } catch (e) {
      await dispatch(setLoader(false));
    } finally {
      await dispatch(setLoader(false));
    }
  };

  const handleSignupIndividual = async (e) => {
    e.preventDefault();
    // console.log("called 2");
    if (!validateForm1()) {
      return;
    }
    const formDatas = new FormData();
    formDatas.append("firstName", formData.firstName);
    formDatas.append("lastName", formData.lastName);
    formDatas.append("email", formData.email);
    formDatas.append("phone", formData.phone);
    formDatas.append("password", formData.password);
    formDatas.append("confirmPassword", formData.confirmPassword);
    formDatas.append("profilePic", formData.profile);
    formDatas.append("userType", "provider");
    formDatas.append("acceptTerms", isChecked);
    formDatas.append("social_id", formData.social_id || 0);
    formDatas.append("businessLicense", formData.businessLicenseInd);
    formDatas.append("passportOrLicense", formData.passportOrLicenseInd);
    formDatas.append("signature", formData.signatureind);
    formDatas.append("services", selectedOption1);
    formDatas.append("for", "individual");
    if (isMarketingSubChecked) {
      formDatas.append("marketingEmail", formData.email);
    } else if (formData.marketingEmail !== "") {
      formDatas.append("marketingEmail", formData.marketingEmail);
    }
    try {
      await dispatch(setLoader(true));
      localStorage.setItem("emailForforget", formData.email);
      await dispatch(registerProvider(formDatas));
      const sendotpRes = await sendOtp({ email: formData.email });
      if (sendotpRes?.data?.status === true) {
        toast.success(sendotpRes.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        props.setRegisterProviderModal(false);
        props.setUserVerifiyOtpModal(true);
        await dispatch(setLoader(false));
      } else {
        toast.warning(sendotpRes.response.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        await dispatch(setLoader(false));
      }
    } catch (e) {
      await dispatch(setLoader(false));
    } finally {
      await dispatch(setLoader(false));
    }
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    if (activeTab == "tabcompany") {
      if (!validateForm()) {
        return;
      }
    } else {
      if (!validateForm1()) {
        return;
      }
    }

    // if activeTab == "tabcompany" ? !validateForm1() ?
    const formDatas = new FormData();
    formDatas.append("firstName", formData.firstName);
    formDatas.append("lastName", formData.lastName);
    formDatas.append("email", formData.email);
    formDatas.append("phone", formData.phone);
    formDatas.append("password", formData.password);
    formDatas.append("confirmPassword", formData.confirmPassword);
    formDatas.append("profilePic", formData.profile);
    formDatas.append("userType", "provider");
    formDatas.append("acceptTerms", isChecked);
    formDatas.append("social_id", formData.social_id || 0);
    if (activeTab == "tabcompany") {
      formDatas.append("businessLicense", formData.businessLicense);
      formDatas.append("passportOrLicense", formData.passportOrLicense);
      formDatas.append("signature", formData.signature);
      formDatas.append("services", selectedOption);
      formDatas.append("for", "company");
    } else {
      formDatas.append("businessLicense", formData.businessLicenseInd);
      formDatas.append("passportOrLicense", formData.passportOrLicenseInd);
      formDatas.append("signature", formData.signatureind);
      formDatas.append("services", selectedOption1);
      formDatas.append("for", "individual");
    }
    try {
      await dispatch(setLoader(true));
      localStorage.setItem("emailForforget", formData.email);
      await dispatch(registerProvider(formDatas));
      const sendotpRes = await sendOtpSignUp({ email: formData.email });
      if (sendotpRes?.data?.status === true) {
        toast.success(sendotpRes.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        props.setRegisterProviderModal(false);
        props.setUserVerifiyOtpModal(true);
        await dispatch(setLoader(false));
      } else {
        toast.warning(sendotpRes.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        await dispatch(setLoader(false));
      }
    } catch (e) {
      await dispatch(setLoader(false));
    } finally {
      await dispatch(setLoader(false));
    }
  };

  const validateStep1 = () => {
    const newErrors = {
      firstName:
        formData.firstName.trim() === "" ? "First name is required" : "",
      lastName: formData.lastName.trim() === "" ? "Last name is required" : "",
      phone:
        formData.phone.trim() === ""
          ? "Phone number is required"
          : !/^\d{10}$/.test(formData.phone.trim())
          ? "Invalid phone number"
          : "",
      email:
        formData.email.trim() === ""
          ? "Email is required"
          : !/^\S+@\S+\.\S+$/.test(formData.email.trim())
          ? "Invalid email address"
          : "",
      password:
        formData.password.trim() === ""
          ? "Password is required"
          : /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/.test(
              formData.password.trim()
            )
          ? ""
          : "Password must be at least 8 characters long and include at least one digit, and one special character",

      confirmPassword:
        formData.confirmPassword.trim() === ""
          ? "Confirm password is required"
          : formData.confirmPassword !== formData.password
          ? "Passwords do not match"
          : "",
      profile: !formData.profile ? "Profile picture is required" : "", // New validation for profile pic
    };

    setErrors(newErrors);

    return !Object.values(newErrors).some((error) => error !== "");
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errorsNext };

    let firstName = formData.firstName.trim().toLowerCase();
    let signature = formData.signature.trim().toLowerCase();
    if (!formData.signature) {
      newErrors.signature = "Signature is required.";
      isValid = false;
    } else if (!signature.includes(firstName)) {
      newErrors.signature =
        "Signature should include your first name for validation.";
      isValid = false;
    } else {
      newErrors.signature = "";
    }

    if (!selectedOption) {
      newErrors.expertise = "Please select your expertise.";
      isValid = false;
    } else {
      newErrors.expertise = "";
    }
    if (showMarketingModal && !isMarketingSubChecked) {
      if (showMarketingModal && formData?.marketingEmail === "") {
        newErrors.marketingEmail = "Marketing email is required.";
        isValid = false;
      } else if (
        showMarketingModal &&
        formData?.marketingEmail !== "" &&
        !/^\S+@\S+\.\S+$/.test(formData.marketingEmail.trim())
      ) {
        {
          newErrors.marketingEmail = "Invalid email address.";
          isValid = false;
        }
      } else {
        newErrors.marketingEmail = "";
      }
    }

    if (!formData.passportOrLicense) {
      newErrors.passportOrLicense = "Passport or Driving license is required.";
      isValid = false;
    } else {
      newErrors.passportOrLicense = "";
    }

    if (!isChecked) {
      newErrors.contract = "You must agree to the Contract waiver.";
      isValid = false;
    } else {
      newErrors.contract = "";
    }

    setErrorsNext(newErrors);

    return isValid;
  };

  const validateForm1 = () => {
    let isValid = true;
    const newErrors = { ...errorsNext1 };
    let firstName = formData.firstName.trim().toLowerCase();
    let signature = formData.signatureind.trim().toLowerCase();
    if (!formData.signatureind) {
      newErrors.signatureind = "Signature is required.";
      isValid = false;
    } else if (!signature.includes(firstName)) {
      newErrors.signatureind =
        "Signature should include your first name for validation.";
      isValid = false;
    } else {
      newErrors.signatureind = "";
    }

    if (showMarketingModal && !isMarketingSubChecked) {
      // console.log("here");
      if (showMarketingModal && formData?.marketingEmail === "") {
        // console.log("here1");
        newErrors.marketingEmail = "Marketing email is required.";
        isValid = false;
      } else if (
        showMarketingModal &&
        formData?.marketingEmail !== "" &&
        !/^\S+@\S+\.\S+$/.test(formData.marketingEmail.trim())
      ) {
        {
          // console.log("here2");
          newErrors.marketingEmail = "Invalid email address.";
          isValid = false;
        }
      } else {
        newErrors.marketingEmail = "";
      }
    }

    if (!selectedOption1) {
      newErrors.expertiseInd = "Please select your expertise.";
      isValid = false;
    } else {
      newErrors.expertiseInd = "";
    }

    if (!formData.passportOrLicenseInd) {
      newErrors.passportOrLicenseInd = "Proof of eligibility is required.";
      isValid = false;
    } else {
      newErrors.passportOrLicenseInd = "";
    }

    if (!isCheckedInd) {
      newErrors.contract = "You must agree to the Contract waiver.";
      isValid = false;
    } else {
      newErrors.contract = "";
    }
    setErrorsNext1(newErrors);
    return isValid;
  };

  const handleNextStep = (e) => {
    if (validateStep1()) {
      setStep((prevStep) => prevStep + 1);
    }
  };

  const onFileChange3 = (e) => {
    setFormData((previous) => ({
      ...previous,
      businessLicenseInd: e.target.files[0],
    }));
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage3(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const onFileChange4 = (e) => {
    setFormData((previous) => ({
      ...previous,
      passportOrLicenseInd: e.target.files[0],
    }));
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage4(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const onHide = () => {
    props.setRegisterProviderModal(false);
    localStorage.removeItem("facebookData");
    localStorage.removeItem("userData");
  };

  return (
    <>
      <Modal size="lg" show={showModal} centered onHide={handleToggleModal}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="pt-0">
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </Modal.Body>
      </Modal>
      <Modal
        size="sm"
        show={props.registerProviderModal}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="pt-0">
          <h2 className="modal-title text-center">Create Account</h2>
          <div className="modal-sub-title">
            Welcome to Helpr! We are here to help with your
            <br /> service requests.
          </div>
          {loading && (
            <div className="loader-container">
              <div className="loader"></div>
            </div>
          )}
          {step === 1 && (
            <Form className="modal-form-wrapper">
              <div className="file-upload-wrapper">
                {image ? (
                  <div className="profile-pic-wrapper">
                    <div className="profile-pic">
                      <img src={image} alt="User" />
                    </div>
                    <div className="remove-img" onClick={handleRemoveImage}>
                      <Trash />
                    </div>
                  </div>
                ) : (
                  <label htmlFor="profile">
                    <ImageUpload />
                    <span>
                      ProfilPic<span className="req-field">*</span>
                    </span>
                    <input id="profile" type="file" onChange={onFileChange5} />
                  </label>
                )}
              </div>
              <span style={{ color: "red", marginLeft: "120px" }}>
                {errors.profile}
              </span>{" "}
              <Form.Group className="mb-3" controlId="firstname">
                <Form.Label>
                  First name<span className="req-field">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  autoComplete="off"
                  name="firstName"
                  value={formData.firstName}
                  onBlur={handleBlur}
                  onChange={handleInputChange}
                  placeholder="Enter your first name"
                />
                <span style={{ color: "red" }}>{errors.firstName}</span>
              </Form.Group>
              <Form.Group className="mb-3" controlId="firstname">
                <Form.Label>
                  Last name<span className="req-field">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  autoComplete="off"
                  name="lastName"
                  value={formData.lastName}
                  onBlur={handleBlur}
                  onChange={handleInputChange}
                  placeholder="Enter your last name"
                />
                <span style={{ color: "red" }}>{errors.lastName}</span>
              </Form.Group>
              <Form.Group className="mb-3" controlId="phoneNumber">
                <Form.Label>
                  Email<span className="req-field">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  autoComplete="off"
                  name="email"
                  value={formData.email}
                  onBlur={handleBlur}
                  onChange={handleInputChange}
                  placeholder="Enter your email"
                />
                <span style={{ color: "red" }}>{errors.email}</span>
              </Form.Group>
              <Form.Group className="mb-3" controlId="phoneNumber">
                <Form.Label>
                  Phone<span className="req-field">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  autoComplete="off"
                  name="phone"
                  value={formData.phone}
                  onBlur={handleBlur}
                  onChange={handleInputChange}
                  placeholder="Enter your phone"
                />
                <span style={{ color: "red" }}>{errors.phone}</span>
              </Form.Group>
              <Form.Group className="mb-3" controlId="password">
                <Form.Label>
                  Password<span className="req-field">*</span>
                </Form.Label>
                <div className="form-wrap">
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    name="password"
                    autoComplete="off"
                    value={formData.password}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    placeholder="Enter your password"
                  />
                  <div className="icon-wrap" onClick={togglePasswordVisibility}>
                    {showPassword ? <Show /> : <Hide />}
                  </div>
                  <span style={{ color: "red" }}>{errors.password}</span>
                </div>
              </Form.Group>
              <Form.Group className="mb-4" controlId="confirmPassword">
                <Form.Label>
                  Confirm Password<span className="req-field">*</span>
                </Form.Label>
                <div className="form-wrap">
                  <Form.Control
                    type={showConfirmPassword ? "text" : "password"}
                    autoComplete="off"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    placeholder="Enter your confirm password"
                  />
                  <div
                    className="icon-wrap"
                    onClick={toggleConfirmPasswordVisibility}
                  >
                    {showConfirmPassword ? <Show /> : <Hide />}
                  </div>
                  <span style={{ color: "red" }}>{errors.confirmPassword}</span>
                </div>
              </Form.Group>
              <Form.Group className="mb-3">
                <div className="d-grid">
                  <Button variant="primary" onClick={handleNextStep}>
                    Next
                  </Button>
                </div>
              </Form.Group>
              <div
                className="form-footer text-center w-100 mb-3"
                onClick={() => {
                  props.setSignUpModal(true);
                  props.setRegisterProviderModal(false);
                }}
              >
                Already have an account? <span>Signin</span>
              </div>
            </Form>
          )}
          {step === 2 && (
            <Form className="modal-form-wrapper">
              <div className="chosse-account">
                <ul>
                  <li
                    onClick={() => handleTabClick("tabcompany")}
                    className={activeTab === "tabcompany" ? "active" : ""}
                  >
                    For Company
                  </li>
                  <li>
                    <div className="divider-line"></div>
                  </li>
                  <li
                    onClick={() => handleTabClick("tabindividual")}
                    className={activeTab === "tabindividual" ? "active" : ""}
                  >
                    For Individual
                  </li>
                </ul>
              </div>
              {activeTab === "tabcompany" && (
                <>
                  <div className="tab-wrapper">
                    <FormGroup className="mb-3 ">
                      <div className="file-upload-wrapper">
                        {image1 ? (
                          <div className="document-proof-wrapper">
                            <div className="doc-img">
                              <img src={image1} alt="Document" />
                            </div>
                            {/* <div className='doc-name text-truncate'>
                            Document name
                          </div> */}
                            <div
                              className="trash-icon"
                              onClick={handleRemoveImage1}
                            >
                              <Trash />
                            </div>
                          </div>
                        ) : (
                          <label htmlFor="businessLicense">
                            <ImageUpload />
                            <span>
                              Add Business License and Certificate of
                              Incorporation (If applicable)
                            </span>
                            <input
                              id="businessLicense"
                              type="file"
                              onChange={onFileChange1}
                            />
                          </label>
                        )}
                      </div>
                      {/* {errorsNext.businessLicense && <span style={{ color: 'red' }}>{errorsNext.businessLicense}</span>} */}
                    </FormGroup>
                    <FormGroup className="mb-3 ">
                      <div className="file-upload-wrapper">
                        {image2 ? (
                          <div className="document-proof-wrapper">
                            <div className="doc-img">
                              <img src={image2} alt="Document" />
                            </div>
                            {/* <div className='doc-name text-truncate'>
                            Document name
                          </div> */}
                            <div
                              className="trash-icon"
                              onClick={handleRemoveImage2}
                            >
                              <Trash />
                            </div>
                          </div>
                        ) : (
                          <label htmlFor="passportOrLicense">
                            <ImageUpload />
                            <span>
                              Passport Or Drivers License
                              <span className="req-field">*</span>
                            </span>
                            <input
                              id="passportOrLicense"
                              type="file"
                              onChange={onFileChange2}
                            />
                          </label>
                        )}
                      </div>
                      {errorsNext.passportOrLicense && (
                        <span style={{ color: "red" }}>
                          {errorsNext.passportOrLicense}
                        </span>
                      )}
                    </FormGroup>
                    <FormGroup className="mb-3">
                      <Form.Label>
                        Select expertise<span className="req-field">*</span>
                      </Form.Label>
                      <Form.Select
                        aria-label="Select your expertise or the services"
                        onChange={handleDropdownChange}
                      >
                        <option value="">
                          Select your primary expertise or service
                        </option>
                        {services.map((service) => (
                          <option key={service._id} value={service._id}>
                            {service.name}
                          </option>
                        ))}
                      </Form.Select>
                      {errorsNext.expertise && (
                        <div style={{ color: "red", marginTop: "0.5rem" }}>
                          {errorsNext.expertise}
                        </div>
                      )}
                    </FormGroup>

                    <Form.Group className="mb-3" controlId="firstname">
                      <Form.Label>
                        Electronic signature<span className="req-field">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="signature"
                        onChange={handleInputChange}
                        placeholder="Enter Your name for Electronic signature"
                      />
                      {errorsNext.signature && (
                        <span style={{ color: "red" }}>
                          {errorsNext.signature}
                        </span>
                      )}
                    </Form.Group>
                    <Form.Group className="mb-4" controlId="termsCondition">
                      <div className="d-flex w-100 align-items-center gap-2 form-check-wrapper">
                        <Form.Check
                          className="mb-0"
                          type="checkbox"
                          id="contract"
                          checked={isChecked}
                          onClick={handleCheckboxClick}
                        />
                        <div>
                          I agree with the{" "}
                          <span onClick={handleToggleModal}>
                            {" "}
                            Contract waiver
                          </span>
                          <br />
                          Confirm contract has been read and accepted
                        </div>
                      </div>
                      {errorsNext.contract && (
                        <span style={{ color: "red" }}>
                          {errorsNext.contract}
                        </span>
                      )}
                    </Form.Group>

                    <div
                      className="form-footer text-center w-100 mb-2"
                      onClick={() => {
                        props.setSignUpModal(true);
                        props.setRegisterProviderModal(false);
                      }}
                    >
                      Already have an account?{" "}
                      <span onClick={redirect}>Sign In</span>
                    </div>
                    <Form.Group className="mb-4">
                      <div className="d-grid">
                        <Button
                          type="submit"
                          onClick={handleSignupCompany}
                          variant="primary"
                          size="lg"
                        >
                          Provider Sign Up
                        </Button>
                      </div>
                    </Form.Group>
                  </div>
                </>
              )}
              {activeTab === "tabindividual" && (
                <>
                  <div className="tab-wrapper">
                    <FormGroup className="mb-3 ">
                      <div className="file-upload-wrapper">
                        {image3 ? (
                          <div className="document-proof-wrapper">
                            <div className="doc-img">
                              <img src={image3} alt="Document" />
                            </div>
                            {/* <div className='doc-name text-truncate'>
                            Document name
                          </div> */}
                            <div className="trash-icon">
                              <Trash />
                            </div>
                          </div>
                        ) : (
                          <label htmlFor="businessLicenseInd">
                            <ImageUpload />
                            <span>
                              Add Business License and Certificate of
                              Incorporation (If applicable)
                            </span>
                            <input
                              id="businessLicenseInd"
                              type="file"
                              onChange={onFileChange3}
                            />
                          </label>
                        )}
                      </div>
                      {/* {errorsNext1.businessLicenseInd && <span style={{ color: 'red' }}>{errorsNext1.businessLicenseInd}</span>} */}
                    </FormGroup>
                    <FormGroup className="mb-3 ">
                      <div className="file-upload-wrapper">
                        {image4 ? (
                          <div className="document-proof-wrapper">
                            <div className="doc-img">
                              <img src={image4} alt="Document" />
                            </div>
                            {/* <div className='doc-name text-truncate'>
                            Document name
                          </div> */}
                            <div className="trash-icon">
                              <Trash />
                            </div>
                          </div>
                        ) : (
                          <label htmlFor="passportOrLicenseInd">
                            <ImageUpload />
                            <span>
                              Upload Passport or Drivers License
                              <span className="req-field">*</span>
                            </span>
                            <input
                              id="passportOrLicenseInd"
                              type="file"
                              onChange={onFileChange4}
                            />
                          </label>
                        )}
                      </div>
                      {errorsNext1.passportOrLicenseInd && (
                        <span style={{ color: "red" }}>
                          {errorsNext1.passportOrLicenseInd}
                        </span>
                      )}
                    </FormGroup>
                    <FormGroup className="mb-3">
                      <Form.Label>
                        Select expertise<span className="req-field">*</span>
                      </Form.Label>
                      <Form.Select
                        aria-label="Select your expertise or the services"
                        onChange={handleDropdownChange2}
                      >
                        {" "}
                        <option value="">
                          Select your primary expertise or service
                        </option>
                        {services.map((service) => (
                          <option key={service._id} value={service._id}>
                            {service.name}
                          </option>
                        ))}
                      </Form.Select>
                      {errorsNext1.expertiseInd && (
                        <div style={{ color: "red", marginTop: "0.5rem" }}>
                          {errorsNext1.expertiseInd}
                        </div>
                      )}
                    </FormGroup>

                    <Form.Group className="mb-3" controlId="firstname">
                      <Form.Label>
                        Electronic signature<span className="req-field">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="signatureind"
                        id="signatureind"
                        onChange={handleInputChange}
                        placeholder="Enter Your name for Electronic signature"
                      />
                      {errorsNext1.signatureind && (
                        <span style={{ color: "red" }}>
                          {errorsNext1.signatureind}
                        </span>
                      )}
                    </Form.Group>
                    <Form.Group className="mb-4" controlId="termsCondition">
                      <div className="d-flex w-100 align-items-center gap-2 form-check-wrapper">
                        <Form.Check
                          className="mb-0"
                          type="checkbox"
                          id="contractInd"
                          checked={isCheckedInd}
                          onClick={handleCheckboxClickInd}
                        />
                        <div>
                          I agree with the{" "}
                          <span onClick={handleToggleModal}>
                            {" "}
                            Contract waivers
                          </span>
                          <br />
                          Confirm contract has been read and accepted
                        </div>
                      </div>
                      {errorsNext1.contract && (
                        <span style={{ color: "red" }}>
                          {errorsNext1.contract}
                        </span>
                      )}
                    </Form.Group>

                    <div
                      className="form-footer text-center w-100 mb-2"
                      onClick={() => {
                        props.setSignUpModal(true);
                        props.setRegisterProviderModal(false);
                      }}
                    >
                      Already have an account?{" "}
                      <span onClick={redirect}>Sign In</span>
                    </div>
                    <Form.Group className="mb-4">
                      <div className="d-grid">
                        <Button
                          type="submit"
                          onClick={handleSignupIndividual}
                          variant="primary"
                          size="lg"
                        >
                          Provider Sign Up
                        </Button>
                      </div>
                    </Form.Group>
                  </div>
                </>
              )}
            </Form>
          )}
          {step === 2 && (
            <>
              <div className="divider mb-4">
                {" "}
                <span>Or</span>
              </div>
              <div className="mb-4 mt-2" style={{ padding: "0px 29px" }}>
                <div className="d-grid">
                  <Button
                    // type="submit"
                    onClick={handleMarketingEmail}
                    variant="primary"
                    size="lg"
                    disabled={checkRequiredFields()}
                  >
                    Marketing Provider Sign Up
                  </Button>
                </div>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
      {showMarketingModal ? (
        <MarketingEmailModal
          showMarketingModal={showMarketingModal}
          handleMarketingModal={handleMarketingModal}
          formDataMarketingEmail={formData.marketingEmail}
          handleBlur={handleBlur}
          handleInputChange={handleInputChange}
          marketingEmailError={
            activeTab === "tabcompany"
              ? errorsNext.marketingEmail
              : errorsNext1.marketingEmail
          }
          activeTab={activeTab}
          handleSignupCompany={handleSignupCompany}
          handleSignupIndividual={handleSignupIndividual}
          isMarketingSubChecked={isMarketingSubChecked}
          setMarketingSubChecked={setMarketingSubChecked}
          handleMarketingSubCheckboxClick={handleMarketingSubCheckboxClick}
        />
      ) : null}
    </>
  );
};

export default RegisterConsumer;
